import React, { useContext } from "react";
import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
// import Avatar from "@mui/material/Avatar";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useLogout, useRedirect } from "react-admin";
import { routePaths } from "../../baseLayout/SidebarMenu";
import { StoreContext } from "./../../store/Store";
import FdButton from "../UIComponents/Button/FdButton";
import FdAvatar from "../UIComponents/Avatar/FdAvatar";
import posthog from "posthog-js";

const UserMenu = () => {
  const logout = useLogout();
  const redirect = useRedirect();
  const [state, dispatch] = useContext(StoreContext);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    dispatch({ type: "SET_CURRENT_USER", payload: null });
    posthog.reset();
    logout();
  };

  const handleProfileClick = () => {
    handleClose();
    redirect(`/${routePaths.PROFILE}`);
  };

  return (
    <Box marginLeft="30px">
      <FdButton
        variant="text"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <FdAvatar
          sx={{ width: 32, height: 32, mr: 1.25 }}
          src={state.currentUser?.image}
        />
        {state.currentUser?.fullName}
      </FdButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        //TODO : commented for mui v5
        // getContentAnchorEl={null}
      >
        {/* <MenuItem onClick={handleClose}>Profile</MenuItem> */}
        <MenuItem onClick={handleProfileClick}>My profile</MenuItem>
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </Box>
  );
};

export default UserMenu;
